import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./lib/auth";
import { Layout } from "./components/Layout";
import Login from "./pages/Login";
import Agendar from "./pages/Agendar";
import Dashboard from "./pages/Dashboard";
import Visitas from "./pages/Visitas";
import Hoje from "./pages/Hoje";
import Matriculas from "./pages/Matriculas";
import NaoEfetivadas from "./pages/NaoEfetivadas";
import Retomada from "./pages/Retomada";
import Orcamentos from "./pages/Orcamentos";
import Valores from "./pages/Valores";
import ValoresMinimos from "./pages/ValoresMinimos";
import Usuarios from "./pages/Usuarios";
import type { Role } from "./lib/tipos";

/** Bloqueia acesso direto pela URL a quem o papel não alcança. */
function Protegida({ minimo, children }: { minimo: Role; children: React.ReactNode }) {
  const { podeAoMenos } = useAuth();
  return podeAoMenos(minimo) ? <>{children}</> : <Navigate to="/" replace />;
}

export default function App() {
  const { usuario, carregando } = useAuth();

  /**
   * A página pública vem antes de tudo: é a família do site, não tem login e
   * não pode esperar a verificação de sessão nem cair no redirecionamento.
   */
  if (window.location.pathname === "/agendar") {
    return (
      <Routes>
        <Route path="/agendar" element={<Agendar />} />
      </Routes>
    );
  }

  if (carregando) {
    return (
      <div style={{ display: "grid", placeItems: "center", minHeight: "100vh", color: "var(--texto-suave)" }}>
        Carregando...
      </div>
    );
  }

  if (!usuario) {
    return (
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    );
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/visitas" element={<Visitas />} />
        <Route path="/hoje" element={<Hoje />} />
        <Route path="/matriculas" element={<Matriculas />} />
        <Route path="/nao-efetivadas" element={<NaoEfetivadas />} />
        <Route path="/retomada" element={<Retomada />} />
        <Route path="/orcamentos" element={<Orcamentos />} />
        <Route path="/valores/mensalidade" element={<Protegida minimo="GESTOR"><Valores tipo="MENSALIDADE" /></Protegida>} />
        <Route path="/valores/material" element={<Protegida minimo="GESTOR"><Valores tipo="MATERIAL" /></Protegida>} />
        <Route path="/valores/bilingue" element={<Protegida minimo="GESTOR"><Valores tipo="BILINGUE" /></Protegida>} />
        <Route path="/valores/minimos" element={<Protegida minimo="GESTOR"><ValoresMinimos /></Protegida>} />
        <Route path="/usuarios" element={<Protegida minimo="ADMIN"><Usuarios /></Protegida>} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  );
}
